// A hand-mirror of src/lister/card/autograph.ts — the SERVER's source of truth for where an
// autograph sits. `ui/` does not import from `src/` (ui/tsconfig.json's `include` is
// ["src", "../tests/ui"]), so this is a second, hand-kept copy, pinned to the real module by
// tests/ui/lister-card-autograph.test.tsx — which is a TEST file and sits outside that
// boundary. Nothing here, and nothing that reads it, may supply a default.
export const AUTOGRAPH_TYPES = ["on_card", "adhered", "none"] as const;
export type ListerAutographType = (typeof AUTOGRAPH_TYPES)[number];

export function autographChoices(): Array<{ code: ListerAutographType; label: string }> {
  return [
    { code: "on_card", label: "On-card autograph" },
    { code: "adhered", label: "Sticker autograph (adhered)" },
    { code: "none", label: "No autograph — the photographs were misread" },
  ];
}
